<template>
    <div>
        <v-menu v-if="user" style="height: 100% !important;" offset-y left origin="right top" z-index="99" content-class="notification-dropdown right-0" transition="slide-y-transition" :nudge-top="$vuetify.breakpoint.name === 'xs' ? '-10' : '0'" :nudge-right="$vuetify.breakpoint.name === 'sm' ? '10' : '0'">
            <v-btn v-if="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs'" slot="activator" icon>
                <img src="/static/avatars/avatarMangaM.jpg" alt="avatar" height="40" width="40" class="img-responsive rounded-circle" />
            </v-btn>
            <v-btn v-else slot="activator" flat class="pa-0 ma-0">
                <v-list-tile>
                    <v-list-tile-avatar>
                        <img src="/static/avatars/avatarMangaM.jpg" alt="avatar" height="40" width="40" class="img-responsive rounded-circle" />
                    </v-list-tile-avatar>
                    <v-list-tile-content class="truncate-content"  style="width: 220px !important;">
                        <v-list-tile-title class="fs-14 fw-bold d-block">{{user.user.name}}</v-list-tile-title>
                        <v-list-tile-sub-title class="d-block fs-12 fw-normal">{{user.user.email}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-btn>
            <div class="dropdown-content">
                <div class="dropdown-top d-custom-flex justify-space-between primary">
                    <span class="white--text fw-bold">Opciones de usuario</span>
                </div>
                <v-list class="dropdown-list">
                    <v-list-tile @click="logoutUser">
                        <i class="ti-power-off mr-3 error--text"></i>
                        <span>Cerrar sesión</span>
                    </v-list-tile>
                    <v-list-tile @click="$refs && $refs.dialogChangePassword.open()">
                        <i class="fas fa-key mr-3 warning--text"></i>
                        <span>Cambiar contraseña</span>
                    </v-list-tile>
                </v-list>
            </div>
        </v-menu>
        <change-password ref="dialogChangePassword"></change-password>
    </div>
</template>
<script>
   import { mapState } from 'vuex'
   export default{
       components: {
           ChangePassword: () => import('./ChangePassword')
       },
       computed: {
           ...mapState({
               user: state => state.auth.user
           })
       },
      methods: {
         logoutUser() {
            this.$store.dispatch('logoutUser')
         }
      }
   }
</script>